import { Col, Input, Row, Select, Typography } from "antd";
import { REWARD_UNIT_OPTIONS } from "features/LoyaltyPackage/core/constants";
import {
  formatAmountInput,
  parseAmountInput,
  validateMilestoneConfigRewardProgression,
} from "features/LoyaltyPackage/core/utils";
import { t } from "i18next";
import { useEffect, useState } from "react";

import { LoyaltyModal, LoyaltyModalFooter, LoyaltyModalTextTitle } from "../../../components/LoyaltyModal";

const { Text } = Typography;

function FieldError({ message }) {
  if (!message) return null;
  return <div className="package-form-milestone-error">{message}</div>;
}

function MilestoneConfigModal({ visible, product, milestones, onCancel, onSave }) {
  const [configs, setConfigs] = useState({});
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (visible && product) {
      const initial = {};
      milestones.forEach((m) => {
        const existing = product.milestoneConfigs?.[m.id];
        initial[m.id] = {
          rewardAmount: existing?.rewardAmount ?? m.rewardAmount,
          rewardUnit: existing?.rewardUnit ?? m.rewardUnit,
        };
      });
      setConfigs(initial);
      setErrors({});
    }
  }, [visible, product, milestones]);

  const handleChange = (milestoneId, field, value) => {
    setConfigs((prev) => ({
      ...prev,
      [milestoneId]: { ...prev[milestoneId], [field]: value },
    }));
    setErrors((prev) => (prev[milestoneId] ? { ...prev, [milestoneId]: undefined } : prev));
  };

  const handleSave = () => {
    const progressionCheck = validateMilestoneConfigRewardProgression(milestones, configs);
    if (!progressionCheck.valid) {
      setErrors(progressionCheck.errors);
      return;
    }

    // Mốc bị để trống giá trị thưởng → bỏ override để ăn theo mốc cha (cả đơn vị & giá trị thưởng)
    const cleanedConfigs = {};
    milestones.forEach((m) => {
      const cfg = configs[m.id];
      if (cfg?.rewardAmount == null) return;
      cleanedConfigs[m.id] = {
        rewardAmount: cfg.rewardAmount,
        rewardUnit: cfg.rewardUnit,
      };
    });
    onSave(product.productId, cleanedConfigs);
    onCancel();
  };

  if (!product) return null;

  return (
    <LoyaltyModal
      visible={visible}
      onCancel={onCancel}
      title={<LoyaltyModalTextTitle>{t("loyaltyPackage.product.configureMilestone")}</LoyaltyModalTextTitle>}
      width={720}
      footer={
        <LoyaltyModalFooter
          onCancel={onCancel}
          onConfirm={handleSave}
          confirmLabel={t("loyaltyPackage.product.applyConfig")}
        />
      }
    >
      {milestones.map((milestone, index) => (
        <div key={milestone.id} className="package-form-milestone-config-block">
          <Text strong className="package-form-milestone-config-block-title">
            {t("loyaltyPackage.product.milestoneShortLabel", { index: index + 1 })}
          </Text>
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <div className="package-form-field">
                <label className="package-form-label">{t("loyaltyPackage.product.rewardValueLabel")}</label>
                <Input
                  className="package-form-input-full"
                  value={formatAmountInput(configs[milestone.id]?.rewardAmount)}
                  onChange={(e) => handleChange(milestone.id, "rewardAmount", parseAmountInput(e.target.value))}
                />
                <FieldError message={errors[milestone.id]} />
              </div>
            </Col>
            <Col xs={24} md={12}>
              <div className="package-form-field">
                <label className="package-form-label">{t("loyaltyPackage.milestone.rewardUnit")}</label>
                <Select
                  className="package-form-input-full"
                  placeholder={t("loyaltyPackage.packageForm.rewardUnitPlaceholder")}
                  options={REWARD_UNIT_OPTIONS}
                  value={configs[milestone.id]?.rewardUnit}
                  onChange={(val) => handleChange(milestone.id, "rewardUnit", val)}
                />
              </div>
            </Col>
          </Row>
        </div>
      ))}
    </LoyaltyModal>
  );
}

export default MilestoneConfigModal;
